<template>
    <iframe
        v-if="link"
        class="custom-iframe"
        :src="link.href"
        :style="{ height: iframeHeight + 'px', width: '100%' }"
      ></iframe>
      <div v-else class="no-link">
        <p>Aucun lien sélectionné.</p>
      </div>
  </template>

<script>
import CONSULTANT_LINKS from '@/gql/queries/consultantLinks.graphql'
import { gqlQuery } from '@/gqlClient.js'

export default {
  name: 'ConsultantLinks',
  data() {
    return {
      iframeHeight: 500,
      links: [],
      link: {
        uid: null,
        label: '',
        href: ''
      }
    };
  },
  async mounted() {
    const self = this;
    this.links = this.$store.state.consultant_link_set;
    const uid = this.$route.params.uid;
    console.log("links", this.links);

    if (uid && this.links !== undefined) {
      this.link = this.links.find(link => link.uid === uid);
    } else {
      const r = await gqlQuery(CONSULTANT_LINKS, {});
      if (r.ok) {
        this.links = r.body.data.consultant_link_set;
        this.link = this.links.find(link => link.uid === uid);
      }
    }

    // Détection du resize
    window.addEventListener('resize', () => {
      self.iframeHeight = document.documentElement.clientHeight - 40;
    });
    self.iframeHeight = document.documentElement.clientHeight - 40;

    // 🔎 Étape 2 – Si l'URL est spécifique, essayer de la fetch
    if (this.link.href === 'https://www.my-hotel-reputation.com/connexion/') {
      try {
        const response = await fetch(this.link.href);
        const html = await response.text();
        console.log('Contenu récupéré :', html.slice(0, 500)); // pour aperçu
        // Tu peux ici parser/redessiner dans une div si besoin
      } catch (error) {
        console.error('Erreur fetch MHR Connexion:', error);
      }
    }
  },
  watch: {
    '$route.params.uid': function (newUid) {
      const uid = newUid;
      if (uid) {
        this.link = this.links.find(link => link.uid === uid);
      }
    }
  }
};
</script>
  
  <style scoped>
    .custom-iframe{
        width:calc(100% + 100px);
        height: 100%;
    }
  .no-link {
    padding: 1rem;
    color: #666;
    text-align: center;
  }
  </style>
  